import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isExternalLink)
    ? (_openBlock(), _createElementBlock("a", _mergeProps({ key: 0 }, _ctx.$attrs, {
        href: _ctx.href,
        target: "_blank",
        class: "cursor-pointer"
      }), [
        _renderSlot(_ctx.$slots, "default")
      ], 16 /* FULL_PROPS */, _hoisted_1))
    : (_openBlock(), _createElementBlock("a", {
        ref: "linkElement",
        key: _ctx.key,
        href: _ctx.sanitizedHref,
        class: _normalizeClass([
			'cursor-pointer',
			_ctx.valid ? (_ctx.hasBang ? 'bg-emerald-900/50' : '') : 'bg-red-500',
			_ctx.hasBang
				? 'select-none ml-1 px-4 py-2 supports-[hover]:hover:bg-emerald-900/20 rounded-xs no-underline supports-[hover]:hover:no-underline whitespace-nowrap'
				: '',
		])
      }, [
        (_ctx.sanitizedInnerText)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.sanitizedInnerText), 1 /* TEXT */))
          : _renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 10 /* CLASS, PROPS */, _hoisted_2))
}